import Panel from "../Panel.js"
import ListItem from "../ListItem.js"

export default class Home extends Panel {

  constructor(props, context) {
    super(props, context)
  }

  static get contextTypes() {
    return super.contextTypes
  }


  clickHandler(object, index) {
    this.setState({activeIndex: index})
    this.props.settingsChange({language: this.listOptions[index]})
  }

  render() {
    this.listOptions = [{label:"Off", value: "off"}]
    this.player.captioning.tracks.forEach((track) => {
      const lang = track.language
      this.listOptions.push({label: this.player.localization.getLanguageString(lang), value: lang})
    })

    const OptionsList = this.listOptions.map((object, index) => {
      let selected = (!this.player.captioning.hidden && this.player.captioning.track && object.value == this.player.captioning.track.language)
      if (this.player.captioning.hidden && index === 0) {
        selected = true
      }
      return <ListItem key={index} onClick={this.clickHandler.bind(this, object, index)} >
              <button className={selected ? 'amp-icon amp-list-item-selected':'amp-icon'} tabIndex="-1"></button>
              <span>{object.label}</span>
             </ListItem>
    })

    return (
      <div ref="element" className="amp-captioning-home">
          <ListItem className="amp-list-highlight" onClick={this.props.gotoSettings.bind(this)} direction="left">
            <button className="amp-icon amp-icon-left" tabIndex="-1"></button>
            <span>Subtitles/CC</span>
          </ListItem>
          <ListItem onClick={(event)=>this.props.viewChange(event, "options")}  className="amp-option-button" >Options</ListItem>
        {OptionsList}
      </div>
    )
  }
}
